export default "__VITE_ASSET__10997804__"